var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import AbstractUrl from '@/support/AbstractUrl';
import { Component, Watch } from 'vue-property-decorator';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import { Subject, SubjectDepthEnum } from '@/models/Subject';
import PageHeader from '@/components/page-header/PageHeader';
import NewSubjectDialog from '@/views/Subjects/Dialogs/NewSubjectDialog';
import SelectFilter from '@/components/select-filter/SelectFilter';
import AreaRow from '@/components/area-row/AreaRow';
import AlertCard from '@/components/alert-card/AlertCard';
import ShowSwapTopicDialog from '@/components/topic-row/ShowSwapTopicDialog';
import ImportSubjects from '@/views/Curricula/ImportSubjects';
import { excludeRoles } from '@/support/ExcludeRoles';
import CurriculumDialog from '@/views/Curricula/CurriculumDialog';
import { downloadExcel } from '@/support/Client';
import { isEmpty, isArray, isFunction, uniqBy, cloneDeep } from 'lodash';
import { RolesEnum } from '@/items/Roles';
import MoveSubjectSnackbar from '@/components/MoveSubjectSnackbar/MoveSubjectSnackbar';
import MoveToAreaDialog from '@/components/MoveToAreaDialog/MoveToAreaDialog';
import MoveSubjectDialog from '@/components/MoveSubjectDialog/MoveSubjectDialog';
let Curriculum = class Curriculum extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Curriculum';
        this.filters = {
            periods: null,
            levels: null,
        };
        this.areas = [];
        this.topics = [];
        this.isLoading = true;
        this.newSubjectDialog = false;
        this.isImporting = false;
        this.selectedSubject = null;
        this.curriculum = new CurriculumModel();
        this.newSubject = null;
        this.nameRules = [(v) => !!v || 'Name is required'];
        this.showSwapDialog = false;
        this.showCurriculumDialog = false;
        this.selectedSwapSubject = new Subject();
        this.isFetchingAreaCounts = false;
        this.hasPrefilled = false;
        this.selectedTopics = [];
        this.isMovingDialogOpen = false;
        this.movingDialogDepth = 0;
        this.isEditing = false;
    }
    get exportCurriculumDialog() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.export', 1, { item: this.$t('dialogOptions.item.curriculum') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        if (!this.curriculum) {
                            return;
                        }
                        const options = {
                            url: `v3/curricula/${this.curriculum.id}`,
                        };
                        downloadExcel(options);
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    // protected getFilterValue(type: string): any {
    //   const filter = this.filters.find((filter) => {
    //     return (filter as any).type === type;
    //   });
    //   if (filter !== undefined && (filter as any).value === undefined) {
    //     return undefined;
    //   }
    //   return (filter as any).value.value;
    // }
    get breadcrumbs() {
        return [{ name: this.$tc('library.title'), path: '/curricula' }, { name: this.curriculum.name || '', path: this.$route.path }];
    }
    get storeSelected() {
        return this.$store.state.selected;
    }
    get curriculumFilters() {
        const curriculumId = this.$route.params.id;
        const filter = {};
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key] === null) {
                return;
            }
            filter[key] = this.filters[key].value;
        });
        return filter;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    get isAuthorized() {
        if (!this.$store.state.Auth) {
            return false;
        }
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]);
    }
    get canSeeButton() {
        const userRoles = this.$store.state.Auth.roles;
        if (typeof userRoles === 'undefined') {
            return false;
        }
        const allowedRoles = [RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.BOARD];
        return !!allowedRoles.some((allowedRole) => userRoles.some((userRole) => userRole.id === allowedRole));
    }
    async created() {
        this.$store.state.selected = [];
    }
    destroyed() {
        this.$store.state.selected = null;
    }
    async onConfirm(area) {
        const subjects = area.depth === SubjectDepthEnum.AREA
            ? this.selectedTopics
            : this.selectedSubjects;
        await this.moveTo(area, subjects);
        this.clearSelection();
        this.initialize();
    }
    onSnackbarClose() {
        this.isMovingDialogOpen = false;
        this.movingDialogDepth = 0;
        this.clearSelection();
    }
    clearSelection() {
        this.$store.state.selected = [];
        this.$store.state.selectedTopics = [];
        this.selectedTopics = [];
    }
    toggleEdit() {
        this.isEditing = !this.isEditing;
    }
    async moveTo(area, movableItems) {
        await new Subject().move({
            target: (area && area.id) || '',
            depth: ((area && area.depth) || 0) + 1,
            subjects: movableItems.map((subject) => subject.id || ''),
        });
        // Move Call..
    }
    get showMoveDialog() {
        return !!(((this.selectedSubjects && this.selectedSubjects.length) || 0)
            + ((this.selectedTopics && this.selectedTopics.length) || 0));
    }
    mounted() {
        if (this.$route.query && !isEmpty(this.$route.query)) {
            this.$nextTick(() => {
                this.preFillSelects(this.$route.query);
            });
        }
        else {
            this.hasPrefilled = true;
        }
        this.initialize();
    }
    onSelectedTopicsChanged(topics) {
        this.selectedTopics = uniqBy(topics, (e) => e.id);
        this.$store.dispatch('selectedTopicsChanged', this.selectedTopics);
        // console.log('onSelectedTopicsChanged');
    }
    get selectedSubjects() {
        return this.$store.state.selected;
    }
    // protected get selectedTopics(): Subject[] {
    //   return this.$store.state.selectedTopics;
    // }
    initialize() {
        if (!this.hasPrefilled) {
            return;
        }
        this.isLoading = true;
        const curriculumId = this.$route.params.id;
        this.areas = [];
        if (curriculumId === 'current') {
            new CurriculumModel()
                .current()
                .filter(this.curriculumFilters)
                .first()
                .then((curriculum) => {
                this.curriculum = curriculum;
                this.$store.dispatch('loadedCurriculum', curriculum);
                if (curriculum.id) {
                    this.getSubjects(curriculum.id);
                }
            })
                .catch(() => {
                this.isLoading = false;
            });
        }
        else {
            new CurriculumModel()
                .find(curriculumId)
                .then((curriculum) => {
                this.curriculum = curriculum;
                this.$store.dispatch('loadedCurriculum', curriculum);
                if (curriculum.id) {
                    this.getSubjects(curriculum.id);
                }
            })
                .catch((error) => {
                if (error.response !== undefined && error.response.status === 404) {
                    this.$router.push('/curricula');
                }
            });
        }
    }
    getSubjects(curriculumId, extendedFilters = {}) {
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key] === null) {
                return;
            }
            extendedFilters[key] = this.filters[key].value;
        });
        extendedFilters.curriculum = this.curriculum.id;
        new Subject()
            .filter(extendedFilters)
            .include(['children', 'subject_labels'])
            .limit(500)
            .all()
            .then((subjects) => {
            this.areas = subjects;
            const topics = [];
            subjects.forEach((area) => {
                if (area.children && area.children.length) {
                    area.children.forEach((topic) => {
                        const clone = cloneDeep(topic);
                        clone.name = `${area.name} - ${topic.name}`;
                        topics.push(clone);
                    });
                }
            });
            this.topics = topics;
            this.curriculum.subjects = subjects;
            this.isLoading = false;
        });
    }
    handleAreaDeleted(area) {
        const index = this.areas.findIndex((subject) => subject.id === area.area.id);
        this.areas.splice(index, 1);
    }
    handleAreaUpdate(area) {
        const index = this.areas.findIndex((subject) => subject.id === area.id);
        if (index < 0) {
            return;
        }
        this.areas[index].is_idp_eligible = area.is_idp_eligible;
        this.areas[index].ignore_status_during_period_change = area.ignore_status_during_period_change;
    }
    handleNewSubject(event) {
        this.initialize();
    }
    preFillSelects(filters) {
        if (filters.levels && this.$refs.levelSelect) {
            this.$refs.levelSelect.setSelected(isArray(filters.levels) ? filters.levels : [filters.levels]);
        }
        if (filters.subject_labels && this.$refs.subjectLabelSelect) {
            this.$refs.subjectLabelSelect.setSelected(isArray(filters.subject_labels) ? filters.subject_labels : [filters.subject_labels]);
        }
        if (filters.periods && this.$refs.periodSelect) {
            this.$refs.periodSelect.setSelected(isArray(filters.periods) ? filters.periods : [filters.periods]);
        }
        this.hasPrefilled = true;
    }
    openExportDialog() {
        this.$store.dispatch('openDialog', this.exportCurriculumDialog);
    }
    authHasRole(roles) {
        return this.$store.state.Auth && isFunction(this.$store.state.Auth.hasRole) ? this.$store.state.Auth.hasRole([roles]) : false;
    }
    onClickOpenImportSubjectsDialog() {
        this.selectedSubject = null;
        this.newSubjectDialog = true;
    }
    get snackbarActions() {
        return [
            {
                icon: 'drive_file_move',
                click: () => {
                    this.movingDialogDepth = 0;
                    this.isMovingDialogOpen = true;
                },
                label: `${this.$tc('move')} ${this.$tc('topics')}`,
                visible: !!(this.selectedTopics && this.selectedTopics.length),
            },
            {
                icon: 'open_with',
                click: () => {
                    this.movingDialogDepth = 1;
                    this.isMovingDialogOpen = true;
                },
                label: `${this.$tc('move')} ${this.$tc('subjects')}`,
                visible: !!(this.selectedSubjects && this.selectedSubjects.length),
            },
        ];
    }
    dialogChange(newValue, oldValue) {
        if (!newValue) {
            this.selectedSubject = null;
        }
    }
    storeSelectedChanged(newValue) {
        if (newValue && newValue.id) {
            this.selectedSwapSubject = newValue;
            this.showSwapDialog = true;
        }
    }
    filtersChanged(newValue) {
        this.isFetchingAreaCounts = false;
        this.setQueryParams({ ...this.curriculumFilters });
        this.initialize();
    }
};
__decorate([
    Watch('newSubjectDialog'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "dialogChange", null);
__decorate([
    Watch('storeSelected'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "storeSelectedChanged", null);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Curriculum.prototype, "filtersChanged", null);
Curriculum = __decorate([
    Component({
        components: {
            MoveSubjectDialog,
            MoveToAreaDialog,
            MoveSubjectSnackbar,
            AlertCard,
            PageHeader,
            NewSubjectDialog,
            SelectFilter,
            AreaRow,
            ShowSwapTopicDialog,
            ImportSubjects,
            CurriculumDialog,
        },
    })
], Curriculum);
export default Curriculum;
